module.exports = __webpack_public_path__ + "img/outreach_black.073bad25.png";